import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Ai.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NodeTypes, ARTIFICIAL_INTELLIGENCE_NODE_DESCRIPTION } from '../../utils';

export const ArtificialIntelligenceNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='AI' description={ARTIFICIAL_INTELLIGENCE_NODE_DESCRIPTION} nodeType={NodeTypes.ARTIFICIAL_INTELLIGENCE} imgPath={stepIcon} />
}